import { DEFAULT_COUNTRY, normalizeCountryCode } from "../../../constants/countries";

/** Build Formik address values with a normalized ISO country code. */
export function customerAddressInitial(record, legacy = {}) {
  if (record?.id) {
    const { country_code, ...rest } = record;
    return {
      ...rest,
      country:
        normalizeCountryCode(country_code || record.country) || DEFAULT_COUNTRY,
    };
  }
  return {
    address: legacy.address || "",
    address2: legacy.address2 || "",
    postal: legacy.postal || "",
    place: legacy.place || "",
    country: normalizeCountryCode(legacy.country) || DEFAULT_COUNTRY,
  };
}

/**
 * Visiting/physical address: keep unset as "" so a routine customer save does
 * not submit a stub object (API update only upserts when address is present).
 */
export function customerPhysicalAddressInitial(record) {
  if (!record?.id) return "";
  return customerAddressInitial(record);
}
